function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { ajax } from "rxjs/ajax";
import { catchError, map } from "rxjs/operators";
import { of } from "rxjs";
import { DownloadReportInput, SearchReportsInput } from "@amzn/coral_com-amazon-transreportscenterservice";
import TransReportsCenterServiceClient from "../clients/TransReportsCenterServiceClient";
import isSiteExternal from "../utils/isSiteExternal";
export function searchReports(param) {
    var term = param.term, reportType = param.reportType, lpAttributesKey = param.lpAttributesKey, pageSize = param.pageSize, logisticsPartyId = param.logisticsPartyId, searchCriteria = param.searchCriteria, sortCriteriaList = param.sortCriteriaList, offset = param.offset;
    var searchReportsInput = SearchReportsInput.clone(_object_spread({
        offset: offset,
        term: term,
        reportType: reportType,
        lpAttributesKey: lpAttributesKey,
        pageSize: pageSize,
        searchCriteria: searchCriteria,
        sortCriteriaList: sortCriteriaList
    }, !isSiteExternal() ? {
        logisticsPartyId: logisticsPartyId
    } : {}));
    return TransReportsCenterServiceClient.searchReports(searchReportsInput);
}
export function downloadReport(param) {
    var reportId = param.reportId, reportType = param.reportType, term = param.term, logisticsPartyId = param.logisticsPartyId;
    var downloadReportInput = DownloadReportInput.clone({
        reportId: reportId,
        reportType: reportType,
        term: term,
        logisticsPartyId: logisticsPartyId
    });
    return TransReportsCenterServiceClient.downloadReport(downloadReportInput);
}
export function getTermReportConfigs() {
    return TransReportsCenterServiceClient.getTermReportConfigs({});
}
export function initiateBatchReportUpload(initiateBatchReportUploadInput) {
    return TransReportsCenterServiceClient.initiateBatchReportUpload(initiateBatchReportUploadInput);
}
export function completeBatchReportUpload(completeBatchReportUploadInput) {
    return TransReportsCenterServiceClient.completeBatchReportUpload(completeBatchReportUploadInput);
}
export function uploadReport(uploadReportInput) {
    return TransReportsCenterServiceClient.uploadReport(uploadReportInput);
}
export var deleteReport = function(deleteReportInput) {
    return TransReportsCenterServiceClient.deleteReport(deleteReportInput);
};
export var uploadWithS3PresignedUrl = function(param) {
    var s3presignedUrl = param.s3presignedUrl, file = param.file;
    return ajax({
        method: "PUT",
        url: s3presignedUrl,
        headers: {
            "Content-Type": "application/octet-stream"
        },
        body: file
    }).pipe(map(function(response) {
        return response;
    }), catchError(function(err) {
        return of(false);
    }));
};
export var generateReportAsync = function(generateReportAsyncInput) {
    return TransReportsCenterServiceClient.generateReportAsync(generateReportAsyncInput);
};
export var generatePresignedUrl = function(generatePresignedUrlInput) {
    return TransReportsCenterServiceClient.generatePresignedUrl(generatePresignedUrlInput);
};
export var downloadWithS3PresignedUrl = function(param) {
    var presignedUrl = param.presignedUrl;
    return ajax({
        url: presignedUrl,
        headers: {
            "Content-Type": "application/octet-stream"
        },
        responseType: "text"
    }).pipe(map(function(response) {
        if (response.status !== 200) {
            throw new Error("Network response was not ok");
        }
        var csvData = response.response;
        return csvData;
    }), catchError(function() {
        return of(false);
    }));
};
export var approveReport = function(approveReportInput) {
    return TransReportsCenterServiceClient.approveReport(approveReportInput);
};
export var rejectReport = function(rejectReportInput) {
    return TransReportsCenterServiceClient.rejectReport(rejectReportInput);
};

//# sourceMappingURL=service.js.map